import { useIntl } from 'react-intl';

import { Button, Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';
import { BaseCard } from '@/components/emotion-detector/shared/BaseCard';

import { ButtonContainer, IntroDescription, IntroExplanation, IntroTitle } from './styles';

interface EmotionIntroProps {
	isVisible: boolean;
	onStartCapture: () => void;
}

export default function EmotionIntro({ isVisible, onStartCapture }: EmotionIntroProps) {
	const { formatMessage } = useIntl();

	if (!isVisible) return null;

	return (
		<BaseCard data-card="intro">
			<IntroTitle>
				<Text el="h2">{formatMessage(messages.cameraIntoTitle)}</Text>
			</IntroTitle>

			<IntroDescription>
				<Text el="p">{formatMessage(messages.cameraIntroDescription)}</Text>
			</IntroDescription>

			<IntroExplanation>
				<Text el="p" color="gray6">
					{formatMessage(messages.cameraIntroExplanation)}
				</Text>
			</IntroExplanation>

			<ButtonContainer>
				<Button backgroundColor="accessibleBrandGradient" onPress={onStartCapture}>
					{formatMessage(messages.cameraIntroCTA)}
				</Button>
			</ButtonContainer>
		</BaseCard>
	);
}
